import { DELETE_ENTERPRISES_ERROR, DELETE_ENTERPRISES_START, DELETE_ENTERPRISES_SUCCESS } from '../../types';

export default function delete_enterprises(state, action) {
  switch (action.type) {
    case DELETE_ENTERPRISES_START:
      return { ...state };
    case DELETE_ENTERPRISES_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_ENTERPRISES_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}